<template>
  <div :class="classData">
    <div class="download" :style="{ zIndex: zIndex }">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="app-name">betterWE星球</div>
        <div class="desc">带你健康吃瘦的体重管理平台</div>
      </div>
      <div class="download-btn">
        App内打开
        <WxOpenLaunchApp class="open-app" :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
  </div>
</template>
<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  components: {
    WxOpenLaunchApp
  },
  props: {
    zIndex: {
      type: Number | String,
      default: 10
    },
    placeholder: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      classData: {},
      extinfo: '' //app额外参数
    }
  },
  created() {
    this.classData = {
      placeholder: this.placeholder,
      [this.position]: true
    }
    this.extinfo = '/web?url=' + encodeURIComponent(location.href)
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.placeholder {
  height: 64px;
}

.top {
  top: 0px;
}

.bottom {
  bottom: 0px;
}

.download {
  position: fixed;
  left: 0;
  width: 100%;
  height: 62px;
  box-sizing: border-box;
  background: #fff;
  padding: 10px 14px;
  display: flex;
  align-items: center;

  .logo {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    object-fit: contain;
    margin-right: 12px;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .app-name {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }

    .desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }
}

.download-btn {
  position: relative;
  padding: 0px 14px;
  height: 28px;
  line-height: 28px;
  background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
  border-radius: 14px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-left: 10px;
}
</style>
